import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './MainCatalogsEditorHome.html?raw';
import on from 'dojo/on';
import { MainCatalogTypes, MainCatalogs_Classes } from "../_loadingHelpers/MainCatalogTypes";
import _TabEnabledMixin from '../../moreCore/UI/Tabbing/_TabEnabledMixin';
import NavigationArea from '../../moreCore/UI/Navigation/NavigationArea';
import MainCatalogList from './MainCatalogList';

/**
 * !! View Klasse - nur zum Testen !!
 */

class MainCatalogsEditorHome extends compose(_WidgetBaseSP, _TabEnabledMixin) {
    templateString: any = template;

    private navigationContainer_OM: HTMLElement;
    private navigationContainer_VAM: HTMLElement;
    private navigationContainer_Process: HTMLElement;
    private navigationContainer_Employment: HTMLElement;
    private navigationContainer_Todo: HTMLElement;
    private navigationContainer_Address: HTMLElement;
    private navigationContainer_File: HTMLElement;
    private navigationContainer_Settings: HTMLElement;
    private navigationArea_OM: MdsLax<InstanceType<typeof NavigationArea>>;
    private navigationArea_VAM: MdsLax<InstanceType<typeof NavigationArea>>;
    private navigationArea_Address: MdsLax<InstanceType<typeof NavigationArea>>;
    private navigationArea_Todo: MdsLax<InstanceType<typeof NavigationArea>>;
    private navigationArea_Process: MdsLax<InstanceType<typeof NavigationArea>>;
    private navigationArea_Employment: MdsLax<InstanceType<typeof NavigationArea>>;
    private navigationArea_File: MdsLax<InstanceType<typeof NavigationArea>>;
    private navigationArea_Settings: MdsLax<InstanceType<typeof NavigationArea>>;
    private tileWidth: string = "20ch";
    private tileMode: any = "strict";

   

    private showContainer(node: HTMLElement, show: boolean = true) {
        this.UiModder.domClass.toggle(node, "w3-show", show !== false);
        setTimeout(lang.hitch(this, this.UiModder.domClass.toggle, node, "hidden", show === false), 50);
        
    }

    private _checkSectionVisiblity(containerNode: HTMLElement, area: MdsLax<InstanceType<typeof NavigationArea>>, tiles: Array<any>) {
        this.createDefaultMenuGroup("navigate");

        if (containerNode && tiles) {
            this.hideNode(containerNode, tiles.length <= 0);

            this.requestContextButton({
                label: area.getHeading(),
                iconClass: "fas fa-arrow-alt-circle-down",
                permanent: false,
                enabled: true,
                name: area.id,
                placement: "actionbar",
                callback: lang.hitch(containerNode, "scrollIntoView", { behaviour: "smooth", inline: "center" }),
                groupName: "navigate"
            });
        }
    }

    private _createNavigationArea() {
        if (this.hasFeature("MainCatalog/OM")) {
            this.navigationArea_OM = new NavigationArea();
            this.navigationArea_OM.placeAt(this.navigationContainer_OM, "only");
            this.navigationArea_OM.setAlignment("left");
            this.navigationArea_OM.setHeading(this.translate("MainCatalogsEditor_MainTitle_OM"));
            on(this.navigationArea_OM, "tilesUpdated", lang.hitch(this, this._checkSectionVisiblity, this.navigationContainer_OM, this.navigationArea_OM));
        }

        if (this.hasFeature("MainCatalog/VAM")) {
            this.navigationArea_VAM = new NavigationArea();
            this.navigationArea_VAM.placeAt(this.navigationContainer_VAM, "only");
            this.navigationArea_VAM.setAlignment("left");
            this.navigationArea_VAM.setHeading(this.translate("MainCatalogsEditor_MainTitle_VAM"));
            on(this.navigationArea_VAM, "tilesUpdated", lang.hitch(this, this._checkSectionVisiblity, this.navigationContainer_VAM, this.navigationArea_VAM));
        }


        if (this.hasFeature("MainCatalog/Address")) {
            this.navigationArea_Address = new NavigationArea();
            this.navigationArea_Address.placeAt(this.navigationContainer_Address, "only");
            this.navigationArea_Address.setAlignment("left");
            this.navigationArea_Address.setHeading(this.translate("MainCatalogsEditor_MainTitle_Address"));
            on(this.navigationArea_Address, "tilesUpdated", lang.hitch(this, this._checkSectionVisiblity, this.navigationContainer_Address, this.navigationArea_Address));
        }

        if (this.hasFeature("MainCatalog/Process")) {
            this.navigationArea_Process = new NavigationArea();
            this.navigationArea_Process.placeAt(this.navigationContainer_Process, "only");
            this.navigationArea_Process.setAlignment("left");
            this.navigationArea_Process.setHeading(this.translate("MainCatalogsEditor_MainTitle_Process"));
            on(this.navigationArea_Process, "tilesUpdated", lang.hitch(this, this._checkSectionVisiblity, this.navigationContainer_Process, this.navigationArea_Process));
        }

        if (this.hasFeature("MainCatalog/Employment")) {
            this.navigationArea_Employment = new NavigationArea();
            this.navigationArea_Employment.placeAt(this.navigationContainer_Employment, "only");
            this.navigationArea_Employment.setAlignment("left");
            this.navigationArea_Employment.setHeading(this.translate("MainCatalogsEditor_MainTitle_Employment"));
            on(this.navigationArea_Employment, "tilesUpdated", lang.hitch(this, this._checkSectionVisiblity, this.navigationContainer_Employment, this.navigationArea_Employment));
        }

        if (this.hasFeature("MainCatalog/Todo")) {
            this.navigationArea_Todo = new NavigationArea();
            this.navigationArea_Todo.placeAt(this.navigationContainer_Todo, "only");
            this.navigationArea_Todo.setAlignment("left");
            this.navigationArea_Todo.setHeading(this.translate("MainCatalogsEditor_MainTitle_Todo"));
            on(this.navigationArea_Todo, "tilesUpdated", lang.hitch(this, this._checkSectionVisiblity, this.navigationContainer_Todo, this.navigationArea_Todo));
        }


        if (this.hasFeature("MainCatalog/File")) {
            this.navigationArea_File = new NavigationArea();
            this.navigationArea_File.placeAt(this.navigationContainer_File, "only");
            this.navigationArea_File.setAlignment("left");
            this.navigationArea_File.setHeading(this.translate("MainCatalogsEditor_MainTitle_File"));
            on(this.navigationArea_File, "tilesUpdated", lang.hitch(this, this._checkSectionVisiblity, this.navigationContainer_File, this.navigationArea_File));
        }

        if (this.hasFeature("MainCatalog/Settings")) {
            this.navigationArea_Settings = new NavigationArea();
            this.navigationArea_Settings.placeAt(this.navigationContainer_Settings, "only");
            this.navigationArea_Settings.setAlignment("left");
            this.navigationArea_Settings.setHeading("MainCatalogsEditor_MainTitle_Settings");
            on(this.navigationArea_Settings, "tilesUpdated", lang.hitch(this, this._checkSectionVisiblity, this.navigationContainer_Settings, this.navigationArea_Settings));
        }
    }


    loadEditForms(): void {

        /* die Userrollen bestimmen, welche Editoren sichtbar sind! */
        this.hasUserRole("MainCatalogsEditor_EvActivityStatus", lang.hitch(this, this._displayEvActivityStatus));
        this.hasUserRole("MainCatalogsEditor_EvBookingStatus", lang.hitch(this, this._displayEvBookingStatus));
        this.hasUserRole("MainCatalogsEditor_Venues", lang.hitch(this, this._displayVenues));
        this.hasUserRole("MainCatalogsEditor_EvRooms", lang.hitch(this, this._displayEvRooms));
        this.hasUserRole("MainCatalogsEditor_ServiceCategories", lang.hitch(this, this._displayServiceCategories));
        this.hasUserRole("MainCatalogsEditor_EvServices", lang.hitch(this, this._displayEvServices));
        this.hasUserRole("MainCatalogsEditor_ServicePackages", lang.hitch(this, this._displayServicePackages));
        

        this.hasUserRole("MainCatalogsEditor_EvCategories_1", lang.hitch(this, this._displayEvCategories1));
        this.hasUserRole("MainCatalogsEditor_EvCategories_2", lang.hitch(this, this._displayEvCategories2));
        this.hasUserRole("MainCatalogsEditor_EvProjectType2", lang.hitch(this, this._displayEvProjectType2));

        this.hasUserRole("MainCatalogsEditor_AddressCategory", lang.hitch(this, this._displayAddressCategories));


        this.hasUserRole("MainCatalogsEditor_DutyTypes", lang.hitch(this, this._displayDutyTypes));

        this.hasUserRole("MainCatalogsEditor_FunctionalGroups", lang.hitch(this, this._displayFunctionalGroups));

        this.hasUserRole("MainCatalogsEditor_EvTaskDescript", lang.hitch(this, this._displayEvTaskDescript));


        this.hasUserRole("MainCatalogsEditor_Todos", lang.hitch(this, this._displayTodos));

        this.hasUserRole("MainCatalogsEditor_FileCategory", lang.hitch(this, this._displayFileCategory));

        this.hasUserRole("MainCatalogsEditor_Professions", lang.hitch(this, this._displayProfessions));

        this.hasUserRole("MainCatalogsEditor_Opus", lang.hitch(this, this._displayOpus));
        this.hasUserRole("MainCatalogsEditor_PostalCodes", lang.hitch(this, this._displayPostalCodes));

        this.hasUserRole("WebTranslationsEditor", lang.hitch(this, this._displayWebTranslations));


        this.hasUserRole("MainCatalogsEditor_EvProcessStatus", lang.hitch(this, this._displayEvProcessStatus));
        this.hasUserRole("MainCatalogsEditor_EvProcessGroupCategorie", lang.hitch(this, this._displayEvProcessGroupCategorie));
        this.hasUserRole("MainCatalogsEditor_EvProcessGroup", lang.hitch(this, this._displayEvProcessGroup));

        this.hasUserRole("MainCatalogsEditor_JobTitle", lang.hitch(this, this._displayJobTitle));
        this.hasUserRole("MainCatalogsEditor_ProfessionalTitles", lang.hitch(this, this._displayProfessionalTitles));
        this.hasUserRole("MainCatalogsEditor_AcademicTitlesPrefix", lang.hitch(this, this._displayAcademicTitlesPrefix));
        this.hasUserRole("MainCatalogsEditor_AcademicTitlesSuffix", lang.hitch(this, this._displayAcademicTitlesSuffix));


        this.hasUserRole("MainCatalogsEditor_PhysicalResources", lang.hitch(this, this._displayPhysicalResources));
        this.hasUserRole("MainCatalogsEditor_Performers", lang.hitch(this, this._displayPerformers));
        this.hasUserRole("MainCatalogsEditor_Composers", lang.hitch(this, this._displayComposers));

        this.hasUserRole("MainCatalogsEditor_InternalInstruments", lang.hitch(this, this._displayInternalInstruments));
        this.hasUserRole("MainCatalogsEditor_ExternalInstruments", lang.hitch(this, this._displayExternalInstruments));

        this.hasUserRole("MainCatalogsEditor_RelationGroups", lang.hitch(this, this._displayRelationGroups));
        this.hasUserRole("MainCatalogsEditor_RelationTypes", lang.hitch(this, this._displayRelationTypes));

        this.hasUserRole("MainCatalogsEditor_SellingStatus", lang.hitch(this, this._displaySellingStatus));
    }

    private _onSelect_Navigation(targetClass: MainCatalogs_Classes, heading: string, color: string) {
        let mcList = new MainCatalogList();

        // TODO/Idee: statt Searchselect einen SelectEntityDlg öffnen
        // darin mehrere Tabs thematisch zusammengefasst anbieten
        // Entity wählen -> Editor in neuem Tab
        // neues Entity -> Editor für neu im Tab

        if (this.isEmbeddedInTab) {
            this.requestNewTabbedContent({
                enableClosing: true,
                label: heading,
                name: targetClass,
                widget: mcList,
                coloration: color,
                groupLabel: heading,
                sidebarEntryName: targetClass
                //iconclass: 
            }, true);
        } else {
            // in Popup maybe
            alert("todo: anzeige wenn nicht in Tab eingebettet noch offen!")
            return;
        }

        mcList.setCatalog(targetClass, heading);

    }

    private _displaySellingStatus(result: boolean): void {
        if (result /*&& this.hasFeature("MainCatalog/SellingStatus")*/) {
            let label = this.translate("General_Label_SellingStatus");
            let color = "w3-teal";
            let entityClass: MainCatalogs_Classes = MainCatalogs_Classes.SellingStatus;
            let icon = "fas fa-receipt";
            let area = this.navigationArea_VAM;

            this.addTileToArea(
                area,
                label,
                color,
                entityClass,
                icon
            )
        }
    }

    private _displayRelationGroups(result: boolean): void {
        if (result) {
            let label = this.translate("General_Label_RelationGroups");
            let color = "w3-light-green";
            let entityClass: MainCatalogs_Classes = MainCatalogs_Classes.RelationGroups;
            let icon = "fas fa-object-ungroup";
            let area = this.navigationArea_Address;

            this.addTileToArea(area,
                label,
                color,
                entityClass,
                icon);
        }
    }

    private _displayRelationTypes(result: boolean): void {
        if (result && this.hasFeature("MainCatalog/RelationTypes")) {
            let label = this.translate("General_Label_RelationTypes");
            let color = "w3-lime";
            let entityClass: MainCatalogs_Classes = MainCatalogs_Classes.RelationTypes;
            let icon = "fas fa-network-wired";
            let area = this.navigationArea_Address;

            this.addTileToArea(area,
                label,
                color,
                entityClass,
                icon);
        }
    }

    private _displayInternalInstruments(result: boolean): void {
        if (!result && this.hasFeature("MainCatalog/OM")) {
            let label = this.translate("General_Label_InternalInstruments");
            let color = "w3-light-green";
            let entityClass: MainCatalogs_Classes = MainCatalogs_Classes.InternalInstrument;
            let icon = "fas fa-guitar";
            let area = this.navigationArea_OM;

            this.addTileToArea(area,
                label,
                color,
                entityClass,
                icon);
        }
    }

    private _displayExternalInstruments(result: boolean): void {
        if (result && this.hasFeature("MainCatalog/OM")) {
            let label = this.translate("General_Label_ExternalInstruments");
            let color = "w3-purple";
            let entityClass: MainCatalogs_Classes = MainCatalogs_Classes.ExternalInstrument;
            let icon = "fas fa-guitar";
            let area = this.navigationArea_OM;

            this.addTileToArea(area,
                label,
                color,
                entityClass,
                icon);
        }
    }

    private _displayComposers(result: boolean): void {
        if (result && this.hasFeature("MainCatalog/Composers")) {
            let label = this.translate("General_Label_Composers");
            let color = "w3-orange";
            let entityClass: MainCatalogs_Classes = MainCatalogs_Classes.Composers;
            let icon = "fas fa-music";
            let area = this.navigationArea_Address;

            this.addTileToArea(area,
                label,
                color,
                entityClass,
                icon);
        }
    }

    private _displayPerformers(result: boolean): void {
        if (result && this.hasFeature("MainCatalog/Performers")) {
            let label = this.translate("General_Label_Performers");
            let color = "w3-purple";
            let entityClass: MainCatalogs_Classes = MainCatalogs_Classes.Performers;
            let icon = "fas fa-guitar";
            let area = this.navigationArea_Address;

            this.addTileToArea(area,
                label,
                color,
                entityClass,
                icon);
        }
    }

    private _displayPhysicalResources(result: boolean): void {


        if (result && this.hasFeature("MainCatalog/PhysicalResources")) {

            let label = this.translate("General_Label_PhysicalResources");
            let color = "w3-purple";
            let entityClass: MainCatalogs_Classes = MainCatalogs_Classes.PhysicalResources;
            let icon = "fas fa-chair";
            let area = this.navigationArea_VAM;

            this.addTileToArea(area,
                label,
                color,
                entityClass,
                icon);
        }
    }

    private _displayEvProjectType2(result: boolean): void {


        if (result) {

            let label = this.translate("General_Label_EvProjectType2");
            let color = "w3-yellow";
            let entityClass: MainCatalogs_Classes = MainCatalogs_Classes.EvProjectType2;
            let icon = "fas fa-cubes";
            let area = this.navigationArea_VAM;

            this.addTileToArea(area,
                label,
                color,
                entityClass,
                icon);
        }
    }

    private _displayVenues(result: boolean): void {
        

        if (result) {

            let label = this.translate("General_Label_Venue");
            let color ="w3-blue-gray";
            let entityClass: MainCatalogs_Classes = MainCatalogs_Classes.Venues;
            let icon = "fas fa-home";
            let area = this.navigationArea_VAM;

            this.addTileToArea(area,
                label,
                color,
                entityClass,
                icon);
        }
    }

    private _displayEvProcessStatus(result: boolean): void {


        if (result) {

            let label = this.translate("General_Label_EvProcessStatus");
            let color = "w3-brown";
            let entityClass: MainCatalogs_Classes = MainCatalogs_Classes.EvProcessStatus;
            let icon = "fas fa-file-alt";
            let area = this.navigationArea_Process;

            this.addTileToArea(area,
                label,
                color,
                entityClass,
                icon);
        }
    }

    private _displayEvProcessGroupCategorie(result: boolean): void {


        if (result) {

            let label = this.translate("General_Label_EvProcessGroupCategorie");
            let color = "w3-brown";
            let entityClass: MainCatalogs_Classes = MainCatalogs_Classes.EvProcessGroupCategorie;
            let icon = "fas fa-clipboard-list";
            let area = this.navigationArea_Process;

            this.addTileToArea(area,
                label,
                color,
                entityClass,
                icon);
        }
    }


    private _displayEvProcessGroup(result: boolean): void {


        if (result) {

            let label = this.translate("General_Label_EvProcessGroup");
            let color = "w3-brown";
            let entityClass: MainCatalogs_Classes = MainCatalogs_Classes.EvProcessGroup;
            let icon = "fas fa-clipboard-list";
            let area = this.navigationArea_Process;

            this.addTileToArea(area,
                label,
                color,
                entityClass,
                icon);
        }
    }

    private _displayFunctionalGroups(result: boolean): void {

        if (result) {
           

            let label = this.translate("General_Label_FunctionalGroup");
            let color = "w3-deep-orange";
            let entityClass: MainCatalogs_Classes = MainCatalogs_Classes.FunctionalGroup;
            let icon = "fas fa-drum";
            let area = this.navigationArea_OM;

            this.addTileToArea(area,
                label,
                color,
                entityClass,
                icon);
        }
    }
    private _displayDutyTypes(result: boolean): void {

        if (result) {
           
            let label = this.translate("General_Label_DutyType");
            let color = "w3-light-blue";
            let entityClass: MainCatalogs_Classes = MainCatalogs_Classes.OMDutyType;
            let icon = "fas fa-cubes";
            let area = this.navigationArea_OM;

            this.addTileToArea(area,
                label,
                color,
                entityClass,
                icon);
        }
    }
    private _displayEvBookingStatus(result: boolean): void {

        if (result) {
           
            let label = this.translate("General_Label_EvBookingStatus");
            let color = "w3-light-green";
            let entityClass: MainCatalogs_Classes = MainCatalogs_Classes.EvBookingStatus;
            let icon = "fas fa-file-alt";
            let area = this.navigationArea_VAM;

            this.addTileToArea(area,
                label,
                color,
                entityClass,
                icon);
        }

    }
    private _displayEvActivityStatus(result: boolean): void {
        if (result) {
           
            let label = this.translate("General_Label_EvActivityStatus");
            let color = "w3-green";
            let entityClass: MainCatalogs_Classes = MainCatalogs_Classes.EvActivityStatus;
            let icon = "fas fa-file-alt";
            let area = this.navigationArea_VAM;

            this.addTileToArea(area,
                label,
                color,
                entityClass,
                icon);
        }
    }
    private _displayEvRooms(result: boolean): void {
        if (result) {
            
            let label = this.translate("General_Label_EvRoom");
            let color = "w3-blue";
            let entityClass: MainCatalogs_Classes = MainCatalogs_Classes.EvRoom;
            let icon = "fas fa-map-marker-alt";
            let area = this.navigationArea_VAM;

            this.addTileToArea(area,
                label,
                color,
                entityClass,
                icon);
        }
        
    }
    private _displayEvServices(result: boolean): void {
        if (result) {
           
            let label = this.translate("General_Label_EvService");
            let color = "w3-amber";
            let entityClass: MainCatalogs_Classes = MainCatalogs_Classes.EvServices;
            let icon = "fas fa-list-ul";
            let area = this.navigationArea_VAM;

            this.addTileToArea(area,
                label,
                color,
                entityClass,
                icon);
        }
    }
    private _displayServiceCategories(result: boolean): void {
        if (result) {
          
            let label = this.translate("General_Label_ServiceCategory");
            let color = "w3-red";
            let entityClass: MainCatalogs_Classes = MainCatalogs_Classes.ServiceCategory;
            let icon = "fas fa-list-alt";
            let area = this.navigationArea_VAM;

            this.addTileToArea(area,
                label,
                color,
                entityClass,
                icon);
        }
    }
    private _displayServicePackages(result: boolean): void {
        if (result) {
           

            let label = this.translate("General_Label_ServicePackage");
            let color = "w3-orange";
            let entityClass: MainCatalogs_Classes = MainCatalogs_Classes.ServicePackage;
            let icon = "fas fa-cube";
            let area = this.navigationArea_VAM;

            this.addTileToArea(area,
                label,
                color,
                entityClass,
                icon);
        }
    }
    private _displayEvCategories1(result: boolean): void {
        if (result) {
            
            let label = this.translate("General_Label_EvCategory1");
            let color = "w3-yellow";
            let entityClass: MainCatalogs_Classes = MainCatalogs_Classes.EvCategory_1;
            let icon = "fas fa-palette";
            let area = this.navigationArea_VAM;

            this.addTileToArea(area,
                label,
                color,
                entityClass,
                icon);
        }
    }

    private _displayEvCategories2(result: boolean): void {
        if (result) {
            
            let label = this.translate("General_Label_EvCategory2");
            let color = "w3-pale-yellow";
            let entityClass: MainCatalogs_Classes = MainCatalogs_Classes.EvCategory_2;
            let icon = "fas fa-palette";
            let area = this.navigationArea_VAM;

            this.addTileToArea(area,
                label,
                color,
                entityClass,
                icon);
        }
        
    }

    private _displayProfessions(result: boolean): void {
        if (result) {

            let label = this.translate("General_Label_Professions");
            let color = "w3-amber";
            let entityClass: MainCatalogs_Classes = MainCatalogs_Classes.Professions;
            let icon = "fas fa-guitar";
            let area = this.navigationArea_VAM;

            this.addTileToArea(area,
                label,
                color,
                entityClass,
                icon);
        }
    }

    private _displayOpus(result: boolean): void {
        if (result) {
            let label = this.translate("General_Label_Opus");
            let color = "w3-red";
            let entityClass: MainCatalogs_Classes = MainCatalogs_Classes.Opus;
            let icon = "fas fa-music";
            let area = this.navigationArea_VAM;

            this.addTileToArea(
                area,
                label,
                color,
                entityClass,
                icon
            )
        }
    }



    private _displayAddressCategories(result: boolean): void {
        if (result) {
            

            let label = this.translate("General_Label_AddressCategory");
            let color = "w3-purple";
            let entityClass: MainCatalogs_Classes = MainCatalogs_Classes.AddressCategory;
            let icon = "fas fa-address-book";
            let area = this.navigationArea_Address;

            this.addTileToArea(area,
                label,
                color,
                entityClass,
                icon);
        }

        if (result) {
            

            let label = this.translate("General_Label_AddressMainCategory");
            let color = "w3-deep-purple";
            let entityClass: MainCatalogs_Classes = MainCatalogs_Classes.AddressMainCategory;
            let icon = "fas fa-address-book";
            let area = this.navigationArea_Address;

            this.addTileToArea(area,
                label,
                color,
                entityClass,
                icon);
        }
        
    }
    private _displayFileCategory(result: boolean): void {

        if (result) {
            

            let label = this.translate("General_Label_FileCategory");
            let color = "w3-deep-purple";
            let entityClass: MainCatalogs_Classes = MainCatalogs_Classes.FileCategory;
            let icon = "fas fa-archive";
            let area = this.navigationArea_File;

            this.addTileToArea(area,
                label,
                color,
                entityClass,
                icon);
        }
    }

    private _displayTodos(result: boolean): void {
       
        if (result) {
            
            let label = this.translate("General_Label_TodoPackages");
            let color = "w3-light-blue";
            let entityClass: MainCatalogs_Classes = MainCatalogs_Classes.TodoPackage;
            let icon = "fas fa-cube";
            let area = this.navigationArea_Todo;

            this.addTileToArea(area,
                label,
                color,
                entityClass,
                icon);
        }

        if (result) {
            
            let label = this.translate("General_Label_TodoDescriptions");
            let color = "w3-blue";
            let entityClass: MainCatalogs_Classes = MainCatalogs_Classes.TodoDescription;
            let icon = "fas fa-tasks";
            let area = this.navigationArea_Todo;

            this.addTileToArea(area,
                label,
                color,
                entityClass,
                icon);
        }

        if (result) {
            
            let label = this.translate("General_Label_TodoCategories");
            let color = "w3-khaki";
            let entityClass: MainCatalogs_Classes = MainCatalogs_Classes.TodoCategory;
            let icon = "fas fa-cubes";
            let area = this.navigationArea_Todo;

            this.addTileToArea(area,
                label,
                color,
                entityClass,
                icon);
        }

        if (result) {

            let label = this.translate("General_Label_TodoStatus");
            let color = "w3-amber";
            let entityClass: MainCatalogs_Classes = MainCatalogs_Classes.TodoStatus;
            let icon = "fas fa-file-alt";
            let area = this.navigationArea_Todo;

            this.addTileToArea(area,
                label,
                color,
                entityClass,
                icon);
        }
    }
    private _displayEvTaskDescript(result: boolean): void {

        if (result) {
            
            let label = this.translate("General_Label_EvTaskDescriptGroup");
            let color = "w3-cyan";
            let entityClass: MainCatalogs_Classes = MainCatalogs_Classes.EvTaskDescriptGroup;
            let icon = "fas fa-file-alt";
            let area = this.navigationArea_Employment;

            this.addTileToArea(area,
                label,
                color,
                entityClass,
                icon);
        }

        if (result) {
            let label = this.translate("General_Label_EvTaskDescript");
            let color = "w3-teal";
            let entityClass: MainCatalogs_Classes = MainCatalogs_Classes.EvTaskDescript;
            let icon = "fas fa-cubes";
            let area = this.navigationArea_Employment;

            this.addTileToArea(area,
                label,
                color,
                entityClass,
                icon);
        }

    }

    private _displayPostalCodes(result: boolean) {
        if (result) {
            let label = this.translate("General_Label_PostalCodes");
            let color = "w3-light-blue";
            let entityClass: MainCatalogs_Classes = MainCatalogs_Classes.PostalCodes;
            let icon = "fas fa-map-pin";
            let area = this.navigationArea_Address;

            this.addTileToArea(
                area,
                label,
                color,
                entityClass,
                icon,
            )
        }
    }

    private _displayWebTranslations(result: boolean) {
        if (result) {
            let label = this.translate("General_Label_WebTranslations");
            let color = "w3-teal";
            let entityClass: MainCatalogs_Classes = MainCatalogs_Classes.WebToolTranslations;
            let icon = "fas fa-language";
            let area = this.navigationArea_Settings;

            this.addTileToArea(
                area,
                label,
                color,
                entityClass,
                icon,
            )
        }
    }

    private _displayJobTitle(result: boolean) {
        if (result) {
            let label = this.translate("General_Label_JobTitleTile");
            let color = "w3-yellow";
            let entityClass: MainCatalogs_Classes = MainCatalogs_Classes.JobTitle;
            let icon = "fas fa-hard-hat";
            let area = this.navigationArea_Address;

            this.addTileToArea(
                area,
                label,
                color,
                entityClass,
                icon,
            )
        }


    }

    private _displayProfessionalTitles(result: boolean) {
        if (result) {
            let label = this.translate("General_Label_ProfessionalTitlesTile");
            let color = "w3-yellow";
            let entityClass: MainCatalogs_Classes = MainCatalogs_Classes.ProfessionalTitles;
            let icon = "fas fa-hard-hat";
            let area = this.navigationArea_Address;

            this.addTileToArea(
                area,
                label,
                color,
                entityClass,
                icon,
            )
        }
    }

    private _displayAcademicTitlesPrefix(result: boolean) {
        if (result) {
            let label = this.translate("General_Label_AcademicTitlesPrefix");
            let color = "w3-yellow";
            let entityClass: MainCatalogs_Classes = MainCatalogs_Classes.AcademicTitlesPrefix;
            let icon = "fas fa-graduation-cap";
            let area = this.navigationArea_Address;

            this.addTileToArea(
                area,
                label,
                color,
                entityClass,
                icon,
            )
        }
    }

    private _displayAcademicTitlesSuffix(result: boolean) {
        if (result) {
            let label = this.translate("General_Label_AcademicTitlesSuffix");
            let color = "w3-yellow";
            let entityClass: MainCatalogs_Classes = MainCatalogs_Classes.AcademicTitlesSuffix;
            let icon = "fas fa-graduation-cap";
            let area = this.navigationArea_Address;

            this.addTileToArea(
                area,
                label,
                color,
                entityClass,
                icon,
            )
        }
    }

    private addTileToArea(navArea: MdsLax<InstanceType<typeof NavigationArea>>, label: string, colorclass: string, entityClass: string, iconclass: string) {

        if (!navArea) return;

        navArea.addTile({
            label: label,
            name: entityClass,
            target: "",
            callback: lang.hitch(this, this._onSelect_Navigation, entityClass, label, colorclass),
            colorclass: colorclass,
            //colorBG: color
            width: this.tileWidth,
            widthMode: this.tileMode,
            iconclass: iconclass
        });
    }

    //BASE
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.RequestManager.handleAs = "json";

        this._createNavigationArea();
    }
    startup(): void {
        super.startup.apply(this, arguments as any);

        this.loadEditForms();

        //this.setTitles(this.translate("MainCatalogsEditor_Navigation"));
    }
}

export default mdsWidget(MainCatalogsEditorHome);